var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"info-text"},[_vm._v("Who are you? (Fileinput)")]),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-10 text-center"},[_c('image-upload',{on:{"change":_vm.onFileChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }